import React from 'react';

import { DocumentsSections } from '@/components/documents/DocumentsSections';
import { CustomerData } from '@/sections/customerManagement/types';

interface CustomerSharingTabProps {
  customer: CustomerData;
}

export const CustomerSharingTab: React.FC<CustomerSharingTabProps> = ({
  customer,
}) => {
  return (
    <DocumentsSections
      query="home"
      customerEmail={customer.email}
      enableUpload={true}
      enableSearch={false}
      enableFavorites={false}
      isPraetorianUser={true}
      sharedWithLabel="Documents Shared with Customer"
      sharedByLabel="Documents Received from Customer"
      sharedWithDescription="Files and reports that have been shared with this customer for review and analysis."
      sharedByDescription="Files and data that this customer has provided for analysis and security assessment."
    />
  );
};
